import { Image } from '@/shared/ui';

import { Button } from '../../Button';
import { Loader } from '@/shared/ui';

import { FormStepButtonId } from './types';

export const DownloadButton: React.FC<{
  text: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  downloading?: boolean;
  place?: 'left-side' | 'right-side' | 'centered';
  outline?: boolean;
  disabled?: boolean;
  withStyles?: boolean;
  className?: string;
}> = ({
  text,
  onClick,
  downloading,
  place = 'left-side',
  disabled = false,
  outline = false,
  withStyles = true,
  className = '',
}) => (
  <Button
    id={FormStepButtonId.download_file}
    className={className}
    isFormButton={withStyles}
    position={withStyles ? place : undefined}
    onClick={onClick}
    outline={outline}
    disabled={disabled}
    withIcon
  >
    {text}
    <span
      style={{
        position: 'relative',
        minHeight: '24px',
        minWidth: '24px',
      }}
    >
      {downloading ? <Loader centered /> : <Image src="/images/save_icon_blue.svg" alt="save file" />}
    </span>
  </Button>
);
